import { render, staticRenderFns } from "./CookieTable.vue?vue&type=template&id=e268f3da&scoped=true"
import script from "./CookieTable.vue?vue&type=script&lang=js"
export * from "./CookieTable.vue?vue&type=script&lang=js"
import style0 from "./CookieTable.vue?vue&type=style&index=0&id=e268f3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e268f3da",
  null
  
)

export default component.exports